<template>
    <v-container grid-list-xl ma-0 pa-0 fluid skeleton>
        <v-layout row wrap v-for="n in 20" :key="n">
            <v-flex skeleton__item skeleton__item-number></v-flex>
            <v-flex skeleton__item skeleton__item-date></v-flex>
            <v-flex skeleton__item skeleton__item-price></v-flex>
            <v-flex skeleton__item skeleton__item-total></v-flex>
            <v-flex skeleton__item skeleton__item-winner></v-flex>
            <v-flex skeleton__item skeleton__item-region></v-flex>
            <v-flex skeleton__item skeleton__item-status></v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "Skeleton",
    data: () => ({}),
    props: {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.skeleton {
    &__item {
        width: 40px;
        position: relative;

        &::before {
            content: "";
            opacity: 0.3;
            display: block;
            height: 25px;
            border-radius: 4px;
            background-image: linear-gradient(
                90deg,
                #ddd 0px,
                #eee 40px,
                #ddd 80px
            );
            background-size: 600px;
            animation: skeletonLoad 0.77s infinite linear;
        }
        &-number {
            width: 4%;
        }
        &-date {
            width: 2%;
        }
        &-price {
            width: 2%;
        }
        &-total {
            width: 2%;
        }
        &-winner {
            width: 30%;
        }
        &-region {
            width: 2%;
        }
        &-status {
            width: 2%;
        }
    }
}
@-webkit-keyframes skeletonLoad {
    from {
        background-position: -240px;
    }
    35% {
        background-position: -90px;
    }
    70% {
        background-position: 90px;
    }
    to {
        background-position: 240px;
    }
}

@keyframes skeletonLoad {
    from {
        background-position: -240px;
    }
    35% {
        background-position: -90px;
    }
    70% {
        background-position: 90px;
    }
    to {
        background-position: 240px;
    }
}
</style>